module.exports = __webpack_public_path__ + "files/dupont.df631b03f9cc924e9bbeb01c3cbb46cc.pdf";